const PALETTE_VARS = [
  '--chart-1','--chart-2','--chart-3','--chart-4','--chart-5',
  '--chart-6','--chart-7','--chart-8','--chart-9',
] as const;

function djb2(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h) ^ s.charCodeAt(i);
  return Math.abs(h);
}

export function getOutcomeColor(outcome: string, canonical: string[]): string {
  if (outcome === 'Unrecorded' || outcome === 'no_outcome') {
    return 'hsl(var(--muted-foreground))';
  }
  const idx = canonical.indexOf(outcome);
  if (idx >= 0 && idx < PALETTE_VARS.length) return `hsl(var(${PALETTE_VARS[idx]}))`;
  const hashIdx = djb2(outcome) % PALETTE_VARS.length;
  return `hsl(var(${PALETTE_VARS[hashIdx]}))`;
}
